"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectionTabContentGrasshopper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const MultiSelectionItemCard_1 = __importDefault(require("../MultiSelectionItemCard"));
const useInfoBoxStateReducer_1 = require("../../hooks/useInfoBoxStateReducer");
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const utils_1 = require("../../utils");
const hooks_1 = require("../../hooks");
const noop_1 = __importDefault(require("lodash/noop"));
function MultiSelectionTabContentGrasshopper({ className, children, items = [], }) {
    const { i18n } = (0, react_i18next_1.useTranslation)();
    const scrollRef = (0, react_1.useRef)();
    const selectedItemRef = (0, react_1.useRef)(null);
    const { selectedItemIndex } = (0, hooks_1.useMultiSelectState)();
    const [, dispatch] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    (0, react_1.useEffect)(() => {
        if (!scrollRef.current || !selectedItemRef.current) {
            return;
        }
        /**
         * Collapse accordion item to get the correct offsetTop
         */
        dispatch((0, useInfoBoxStateReducer_1.expandItem)(false));
        scrollRef.current.scrollTo(0, selectedItemRef.current.offsetTop);
        /**
         * Expand accordion item after scrolling
         */
        dispatch((0, useInfoBoxStateReducer_1.expandItem)(true));
    }, [dispatch, selectedItemIndex]);
    return ((0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'MultiSelectionTabContentGrasshopper_Container', children: (0, jsx_runtime_1.jsx)(StyledScrollView, { ref: scrollRef, className: className, role: "list", "data-e2e": 'MultiSelectionTabContentGrasshopper_StyledScrollView', children: (children !== null && children !== void 0 ? children : items).map((item, i) => ((0, jsx_runtime_1.jsx)(StyledMultiSelectionItemCard, Object.assign({ ref: selectedItemIndex === i ? selectedItemRef : noop_1.default }, item, { onClick: noop_1.default, isGrasshopper: true, isSelected: selectedItemIndex === i, identifier: item.identifier, index: i, "data-e2e": 'MultiSelectionTabContentGrasshopper_StyledMultiSelectionItemCard', children: item.information && ((0, jsx_runtime_1.jsx)(Information, { "data-e2e": 'MultiSelectionTabContentGrasshopper_Information', children: (0, utils_1.parseInfoBoxDescription)(item.information, i18n.language) })) }), item.identifier))) }) }));
}
exports.MultiSelectionTabContentGrasshopper = MultiSelectionTabContentGrasshopper;
const StyledMultiSelectionItemCard = (0, styled_components_1.default)(MultiSelectionItemCard_1.default) `
  & button {
    visibility: visible;
    opacity: 1;
    margin-right: 5px;
    margin-top: 5px;
  }
  padding: 0;
  margin-bottom: 16px;
  margin-right: 9px;
  padding: 4px 8px;
  border-radius: 4px;

  &:hover {
    cursor: default;
  }
`;
const Container = styled_components_1.default.div `
  padding: 8px;
  display: flex;
  overflow: hidden;
`;
const StyledScrollView = styled_components_1.default.div `
  width: 100%;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.grasshopper.background};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grasshopper.descriptionPanel.scroll.idle};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }
`;
const Information = styled_components_1.default.div `
  font-size: 13px;
`;
